export default class DuplicateKickoff extends Error {
    constructor() {
        super("Kickoff already exists!");
    }
}
